import React, { useState, useEffect } from "react";
import { api } from "../../services/api";
import { SetupProgressIndicator } from "./SetupProgressIndicator";

interface DashboardProgressIndicatorProps {
  onOpenWizard: () => void;
}

export const DashboardProgressIndicator: React.FC<DashboardProgressIndicatorProps> = ({
  onOpenWizard,
}) => {
  const [progress, setProgress] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProgress();
  }, []);

  const fetchProgress = async () => {
    try {
      const response = await api.get("/store/setup-progress");
      setProgress(response.data);
    } catch (err) {
      console.error("Failed to fetch progress:", err);
    } finally {
      setLoading(false);
    }
  };

  // Only show if not 100% complete
  if (loading || !progress || progress.overallProgress >= 100) {
    return null;
  }

  return <SetupProgressIndicator onOpenWizard={onOpenWizard} />;
};

